import { css } from "styled-components";

export const Centralized = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`